import React, { useState } from 'react';
import { TouchableOpacity, View } from '../../../../../../components/Common/react-native-components';
import { Icons, Popup, Typography } from '@hmsexp/component-library';
import SidebarContent from './SidebarContent';

const SidebarComponent = props => {
  const { visible, selectedCardId, setSelectedCardId, selectedCardData, onClose } = props;

  const [isBigSize, setIsBigSize] = useState(false);

  const renderContent = () => {
    return (
      <SidebarContent
        selectedCardId={selectedCardId}
        setSelectedCardId={setSelectedCardId}
        selectedCardData={selectedCardData}
      />
    );
  };
  function renderHeader() {
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: 20,
          borderBottomWidth: 1
        }}>
        <Typography variant='h6'>{selectedCardData?.title}</Typography>
        <View style={{ flexDirection: 'row', gap: 15, alignItems: 'center' }}>
          <TouchableOpacity
            style={{
              transform: [{ rotate: `${isBigSize ? 180 : 0}deg` }],
              transition: 'all 0.4s ease'
            }}
            onPress={() => setIsBigSize(!isBigSize)}>
            <Icons.ChevronLeft size='XL' />
          </TouchableOpacity>
          <View>
            <TouchableOpacity onPress={onClose}>
              <Icons.Cross />
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }

  return (
    <Popup
      onClose={onClose}
      showFooter={false}
      showCloseIcon={false}
      isScrollableContent
      position={'right'}
      renderHeader={renderHeader}
      renderContent={renderContent}
      visible={visible}
      style={{
        contentPosition: {
          width: isBigSize ? 900 : 450,
          transition: 'all 0.4s ease',
          maxWidth: 1000
        }
      }}
    />
  );
};
export default SidebarComponent;
